import API from "@api/api"
import { Alert, Button, Modal, Space, message } from "antd"
import { ExclamationCircleFilled } from '@ant-design/icons';
import eventBus from '@utils/eventBus';
import { MODEL_PARAMS, DRESSFORM_PARAMS, COMMODITY_PARAMS, TRYON_PARAMS } from './BUILD_PARAMS_CONST'
import axios from 'axios';
import Utils from '@utils/utils'
import { HOME_PAGE_TYPE, IMAGE_TYPE, ALGO_TYPE } from "@utils/CONST"
import { CLOTH_TYPE } from "./CONST";
import PSAIModal from "@PSAIComponents/PSAIModal";
import {maskPrediction} from './workflowOfPrediction'

const checkInpaintPredictionParamsExpired = (params, taskId, projectName, imageType, errorCallback) => {
    const formartParams = {...params}
    const staticParams = (
        imageType == IMAGE_TYPE.MODEL?
            MODEL_PARAMS :
            imageType == IMAGE_TYPE.CLOTHES ?
                TRYON_PARAMS :
                imageType == IMAGE_TYPE.COMMODITY ?
                    COMMODITY_PARAMS :
                    DRESSFORM_PARAMS
    )
    for (let param of staticParams) {
        if (!formartParams.hasOwnProperty(param.key)) {
            if (param.hasOwnProperty('default')) {
                formartParams[param.key] = param.default
            } else {
                console.log('can`t continue...', 1)
                PSAIModal.confirm({
                    title: '无法继续，需重选模特和场景后生成',
                    content: '版本已更新，无法复用之前的选择，请重选模特和场景',
                    okText: '去重选',
                    cancelText: '取消',
                    onOk() {
                        errorCallback ? errorCallback() : reselectModelAndBackground(taskId, imageType, projectName)
                    },
                    onCancel() {},
                })
                return Promise.resolve({ isNotExpired: false })
            }            
        } 
    }
    // if (formartParams.defined_flag == 1) {
    //     formartParams.keep_bkg = 0
    // } else {
    //     if (formartParams.keep_bkg == 1) {
    //         // 场景裂变
    //     } else if (formartParams.mote_bg_style == '00_keep') {
    //         formartParams.keep_bkg = 2
    //     } else {
    //         formartParams.keep_bkg = 0
    //     }
    // }
    return Promise.resolve({ isNotExpired: true, formartParams })
}

// 算法处理函数
const inpaintPrediction = (buildParams, imageType, replica=false) => {
    let api = API.inpaintPrediction
    if (imageType == IMAGE_TYPE.MODEL) api = API.inpaintPrediction
    if (imageType == IMAGE_TYPE.CLOTHES) api = API.virtualtryonPrediction
    if (imageType == IMAGE_TYPE.DRESSFORM) api = API.aidressformPrediction
    if (imageType == IMAGE_TYPE.COMMODITY) api = API.inpaintPredictionGoods
    return api(buildParams, replica ? {num: 4} : null).then(res => {
        if (!res || res.code != 0 || !res.data) {
            if (res.code == -5012) {
                PSAIModal.confirm({
                    title: "提醒",
                    content: "可用虹豆不足，是否立即充值？",
                    onOk() {
                        eventBus.emit('recharge')
                    },
                    onCancel() {},
                })
                return false
            } else throw new Error(res?.message || '算法生成失败，请联系客服')
        }

        eventBus.emit('updatePower')
        
        return res.data
    }).catch(err => {
        message.error(err?.message)
    })
}

// 项目生成函数
const projectCreate = ({ id, imageType, algoType, inpaint, inputImage, mask, projectName, imageAntispamId }) => {
    return API.projectCreate({
        id: id,
        projectName: projectName,
        imageType: imageType,
        algoType,
        inputImage: inputImage,
        inpaint: inpaint,
        mask: mask,
        imageAntispamId: imageAntispamId
    }).then(res => {
        if (!res || res.code != 0 || !res.data) {
            throw new Error(res?.message || '任务生成失败，请稍后重试')
        }
        return res.data
    }).catch(err => {
        message.error(err?.message)
    })
}

// 检查任务生成状态
const checkTaskStatus = (taskList) => {
    return Promise.all(
        taskList.map(item => API.getTaskImages({ taskId: item.taskId }))
    ).then((res) => {
        let failRes = res.find(item => item.code !== 0 || !item.data)
        if (failRes) {
            throw new Error(failRes?.message)
        }
        if (res.find(item => item?.data?.inpaint?.status == 'failed')) {
            throw new Error('生成失败，请稍后重试')
        } else {
            message.info('生成中，请稍等片刻')
            return true
        }
    }).catch(err => {
        message.error(err?.message)
        return false
    })
}

const reselectModelAndBackground = (taskId, imageType, projectName) => {
    API.getTaskInfo({
        taskId: taskId
    }).then(res => {
        if (!res || res.code != 0 || !res.data) throw new Error(res?.message)
        const input = res?.data?.inpaint?.input
        const attr = res?.data?.inpaint?.attr
        const mask = res?.data?.mask
        const filter = attr?.modelFilter || 
            localStorage.getItem('filter') ? JSON.parse(localStorage.getItem('filter')) : null
        let clothType = CLOTH_TYPE.SKIRT
        if (imageType == IMAGE_TYPE.CLOTHES) {
            if (!mask?.algoId) clothType = CLOTH_TYPE.SUIT
        }

        // 原始输入图
        let inputImage, inputImageTop, inputImageBottom
        const topAlgoId = mask?.topAlgoId
        const bottomAlgoId = mask?.bottomAlgoId
        const _inputImage = res?.data?.inputImage || ""
        const inputImageArray = _inputImage ? _inputImage.split(',') : []
        if (topAlgoId && bottomAlgoId) {
            inputImageTop = inputImageArray[0] || mask?.topEditedOutput[0]
            inputImageBottom = inputImageArray[1] || mask?.bottomEditedOutput[0]
        } else if (topAlgoId) {
            inputImageTop = inputImageArray[0] || mask?.topEditedOutput[0]
        } else if (bottomAlgoId) {
            inputImageBottom = inputImageArray[0] || mask?.bottomEditedOutput[0]
        } else {
            inputImage = inputImageArray[0] || mask?.editedOutput[0]
        }

        let imgRatio = attr?.imgRatio || '1:1'
        if (!input?.hasOwnProperty('coord_drag') && imageType == IMAGE_TYPE.MODEL) {
            imgRatio = 'recommend'
        }
        let refStrength = 0.5
        if (imageType == IMAGE_TYPE.MODEL) {
            const ip_scale = input?.hasOwnProperty('ip_scale') ? input?.ip_scale : 0.5
            refStrength = Number(ip_scale)
        } else if (imageType == IMAGE_TYPE.COMMODITY) {
            refStrength = (input?.refine_version == 1 ? input?.ref_strength : input?.ref_prompt_strength) || 0.3
        }
        sessionStorage.setItem(`taskCache_${imageType}`, JSON.stringify({
            inputImage: inputImage,
            inputImageTop: inputImageTop,
            inputImageBottom: inputImageBottom,

            modelFilter: filter,
            dragScale: input?.imgs_dict,

            lt_x: input?.lt_x || 0,
            lt_y: input?.lt_y || 0,
            scaleRate: input?.scale_rate || 1,

            coordDrag: input?.coord_drag ? JSON.parse(input?.coord_drag) : null,

            maskAlgoId: mask?.algoId,
            maskAlgoId1: mask?.topAlgoId,
            maskAlgoId2: mask?.bottomAlgoId,

            segmentResult: mask?.editedOutput,
            segmentResult1: mask?.topEditedOutput,
            segmentResult2: mask?.bottomEditedOutput,

            modelStyle: attr?.person,
            poseStyle: attr?.pose,
            bgStyle: attr?.background,

            projectId: res.data.projectId,
            rightProjectId: res.data.projectId,
            projectName: projectName,
            clothType: clothType, //+++++++++
            createNum: input?.num || 4,

            imgRatio: imgRatio,
            imgWidth: input?.canvas_width || 1024,
            imgHeight: input?.canvas_height || 1024,

            definedFlag: input?.defined_flag,
            positivePrompt: input?.p_prompt || input?.prompt,
            refImg: input?.ref_img || input?.bkg_url,
            refImgMask: input?.ref_img_mask,
            refVersion: input?.refine_version || 2,
            refStrength: refStrength,
            faceTag: attr?.faceTag || 'default',
            hairTag: attr?.hairTag || 'default',
            faceTagText: attr?.faceTagText || '默认',
            hairTagText: attr?.hairTagText || '默认',

            isSceneFracturing: input.keep_bkg == 1,
            dpScale: input.dp_scale,

            keepPose: input.keepPose == 1 ? true : false,
        }))

        eventBus.emit('navigateTo', `/home/homemain/${imageType}`, { state: {rebuild: true}})
    }).catch(err => {
        message.error(err?.message)
    })
}

const checkBgAndModelExpired = (imageType, taskId, projectName, attr, lastInput={}, errorCallback) => {
    const { background, person, pose } = attr
    const {
        mote_bg_style,
        mote_style, // 模特参数
        bkg_style, // tryon的场景参数
        person_style, // tryon的姿势参数
    } = lastInput
    const bgApi = imageType == IMAGE_TYPE.COMMODITY ?
                    API.commodityBackgroundList : API.modelBackgroundList
    const modelApi = API.modelPersonList
    const poseApi = API.modelTryOnList
    return Promise.all([
        modelApi(),
        poseApi(),
        bgApi()
    ]).then(([modelRes, poseRes, bgRes]) => {
        if (!modelRes || modelRes.code != 0 || !modelRes.data) throw new Error(modelRes?.message)
        if (!poseRes || poseRes.code != 0 || !poseRes.data) throw new Error(poseRes?.message)
        if (!bgRes || bgRes.code != 0 || !bgRes.data) throw new Error(bgRes?.message)
        let bgPass = true
        let modelPass = true
        let posePass = true
        if (background) bgPass = !!bgRes.data.find(item => item.name == background || item.subList?.find(subitem => subitem.name == background)) // 场景
        if (mote_bg_style) bgPass = !!bgRes.data.find(item => item.name == mote_bg_style || item.subList?.find(subitem => subitem.name == mote_bg_style)) // 场景
        if (bkg_style) bgPass = !!bgRes.data.find(item => item.name == bkg_style || item.subList?.find(subitem => subitem.name == bkg_style)) // tryon的场景
        if (person) modelPass = !!modelRes.data.find(item => item.name == person || item.subList?.find(subitem => subitem.name == person)) // 模特
        if (mote_style) modelPass = !!modelRes.data.find(item => item.name == mote_style || item.subList?.find(subitem => subitem.name == mote_style)) // 模特
        if (pose) posePass = !!poseRes.data.find(item => item.name == pose || item.subList?.find(subitem => subitem.name == pose)) // 姿势
        if (person_style) posePass = !!poseRes.data.find(item => item.name == person_style || item.subList?.find(subitem => subitem.name == person_style)) // tryon的姿势
        if (bgPass && modelPass && posePass) {
            return true
        } else {
            let content = ''
            let title = ''
            if (!bgPass && !modelPass) {
                content = '原模特和场景组已更新，无法复用之前的选择，请重选模特和场景后生成'
                title = '无法继续，需重选模特和场景后生成'
            } else if (!bgPass) {
                content = '原场景组已更新，无法复用之前的选择，请重选场景'
                title = '无法继续，需重选场景后生成'
            } else if (!modelPass) {
                content = '原模特组已更新，无法复用之前的选择，请重选模特'
                title = '无法继续，需重选模特后生成'
            } else if (!posePass) {
                content = '原姿势已更新，无法复用之前的选择，请重选姿势'
                title = '无法继续，需重选姿势后生成'
            }
            console.log('can`t continue...', 2)
            PSAIModal.confirm({
                title: title,
                content: content,
                okText: '去重选',
                cancelText: '取消',
                onOk() {
                    errorCallback ? errorCallback() : reselectModelAndBackground(taskId, imageType, projectName)
                },
                onCancel() {},
            })
            return false
        }
    }).catch(err => {
        message.error(err?.message)
    })
}

const updateInpaintPredictionParamsForRandom = (params, attr, imageType, taskId, projectName) => {
    const { background, modelFilter, clothCategory } = attr
    const bgApi = imageType == IMAGE_TYPE.COMMODITY ?
                    API.commodityBackgroundList : API.modelBackgroundList
    const modelApi = API.modelPersonList
    return Promise.all([
        modelApi({
            age: modelFilter?.age?.join(),
            sex: modelFilter?.sex?.join(),
            skin: modelFilter?.skin?.join(),
        }),
        bgApi({
            categoryId: clothCategory
        })
    ]).then(([modelRes, bgRes]) => {
        if (!modelRes || modelRes.code != 0 || !modelRes.data) throw new Error(modelRes?.message)
        if (!bgRes || bgRes.code != 0 || !bgRes.data) throw new Error(bgRes?.message)
        
        if (imageType != IMAGE_TYPE.COMMODITY) {
            // 模特随机的keylist
            if (!modelFilter?.age || modelFilter?.age.length == 0) {
                // 不特意删选时，随机模特过滤掉儿童
                params.modelKeyList = modelRes
                    .data
                    .filter(item => item?.attr?.age != 'children' && !/_default_style$/.test(item.name))
                    .map(item => item.name) // modalStyle传随机(_default_style)时使用
            } else {
                params.modelKeyList = modelRes.data.filter(item => !/_default_style$/.test(item.name)).map(item => item.name) // modalStyle传随机(_default_style)时使用
            } 
        }            
        // 场景随机的keylist
        // 纯色背景
        const solid_background = bgRes.data
            .filter(item => /solid_background/.test(item.name))
            .map(item => [...item.subList.filter(i => !/_solid_background_random$/.test(i.name)).map(i => i.name)])
            .flat()
        // 窗幔布艺
        const drapery_background = bgRes.data
            .filter(item => /drapery_background/.test(item.name))
            .map(item => [...item.subList.filter(i => !/_drapery_background_random$/.test(i.name)).map(i => i.name)])
            .flat()
        // 没有subList的背景
        const no_subList_background = bgRes.data
            .filter(item => (!/_random$/.test(item.name) && !/_keep$/.test(item.name) && !/solid_background/.test(item.name) && !/drapery_background/.test(item.name)))
            .map(item => item.name)
        let bgList = []
        if (/_solid_background_random$/.test(background)) {
            bgList = solid_background
        } else if (/_drapery_background_random$/.test(background)) {
            bgList = drapery_background
        } else {
            bgList = [
                ...no_subList_background,
                ...solid_background,
                ...drapery_background
            ]
        }
        params.bgKeyList = bgList // bgUrl传随机(_random)时使用
        
        if (
            (imageType != IMAGE_TYPE.COMMODITY && params.modelKeyList.length == 0) ||
            params.bgKeyList.length == 0
        ) {
            console.log('can`t continue...', 3)
            PSAIModal.confirm({
                title: '无法继续，需重选模特和场景后生成',
                content: '版本已更新，无法复用之前的选择，请重选模特和场景',
                okText: '去重选',
                cancelText: '取消',
                onOk() {
                    reselectModelAndBackground(taskId, imageType, projectName)
                },
                onCancel() {},
            })
            return false
        }        
        return params
    })
}

const updateInpaintPredictionParamsForReplica = async (params, file, imageType, inpaintAttr) => {
    const maskRes = await maskPrediction(file, imageType)
    if (maskRes) {
        const {id, input, output: segmentResult} = maskRes
        if (imageType == IMAGE_TYPE.MODEL) {
            if (params?.hasOwnProperty('coord_drag')) params.coord_drag = "" // 复刻不能调整背景,需要将coord_drag置空
            params.img_path = segmentResult[0]
            params.mask_path = segmentResult[3]
            params.mask_path_cloth = segmentResult[4]
            params.skin_maskpath = segmentResult[5] || '' // 模特增加手部mask 
            params.hair_maskpath = segmentResult[6] || '' // 模特增加发型mask 
            params.tryon_flag = 0
            // params.scale_rate = Number(params.scale_rate)
        } else if (imageType == IMAGE_TYPE.DRESSFORM) {
            params.img_path = segmentResult[0]
            params.mask_path_cloth = segmentResult[4]
            params.body_mask_path = segmentResult[3]
        } else if (imageType == IMAGE_TYPE.CLOTHES) {
            params.cloth_path = segmentResult[0]
            params.cloth_mask = segmentResult[4]
        }
        return { params: params, maskAlgoId: id, editedOutput: segmentResult, inputImage: input.image }
    }
}
// 复刻的流程
export const workflowOfReplica = async (taskId, imageType, projectName, file, imageAntispamId, errorCallback) => {
    if (imageType == IMAGE_TYPE.COMMODITY || imageType == IMAGE_TYPE.CLOTHES) {
        message.warning('不支持此操作')
        return false
    }
    try {
        const [ver, res] = await Promise.all([
            API.getVersion(), // 单独调用接口，获取version，用来替换以前任务的version
            API.getTaskInfo({ taskId: taskId })
        ])
        if (!res || res.code != 0 || !res.data) throw new Error(res?.message)

        const version = 
            (imageType == IMAGE_TYPE.COMMODITY ? // 商品
                ver?.commodityVersion :
                imageType == IMAGE_TYPE.CLOTHES ? // tryon
                    ver?.tryOnVersion :
                    ver?.modelVersion
            ) ||
            res.data.inpaint?.attr?.version // 兼容写法
        const projectId = res.data.projectId
        const lastInput = res.data.inpaint?.input
        const lastInpaintAttr = res.data.inpaint?.attr // 此处需要检查模特/场景是否有更新
        const lastMask = res.data.mask
        const lastInputImage = lastMask?.input

        const { mote_bg_style, mote_style } = lastInput
        if ((/_random$/.test(mote_bg_style) || /_default_style$/.test(mote_style))) { // 随机时不能复刻
            message.warning('版本已更新，旧版随机生成的任务不支持复用模特/场景')
            return false
        }

        const BgAndModelIsNotExpired = await checkBgAndModelExpired(imageType, taskId, projectName, lastInpaintAttr, lastInput, errorCallback)
        if (!BgAndModelIsNotExpired) return false

        let {isNotExpired, formartParams} = await checkInpaintPredictionParamsExpired({...lastInput, version}, taskId, projectName, imageType, errorCallback)
        if (!isNotExpired) return false

        // 20231010 复刻改成生成4张图，需要重置seed和sub_bgid
        // 20231123 客户反馈复刻生产的模特不一致，改为固定seed和sub_bgid
        // formartParams.seed = -1
        // formartParams.sub_bgid = -1

        const res2 = await updateInpaintPredictionParamsForReplica(formartParams, file, imageType, lastInpaintAttr)
        if (!res2) return

        const { params, maskAlgoId, editedOutput, inputImage } = res2

        // 生成图片数，默认为4
        formartParams.num = formartParams.num || 4

        const inpaintAlgoId = await inpaintPrediction(params, imageType, true)
        if (!inpaintAlgoId) return false

        // 算法类型
        const algoType = 
            imageType == IMAGE_TYPE.MODEL ? ALGO_TYPE.MODEL :
            imageType == IMAGE_TYPE.DRESSFORM ? ALGO_TYPE.DRESSFORM :
            imageType == IMAGE_TYPE.COMMODITY ? (
                params.refine_version == 3 ?
                    ALGO_TYPE.COMMODITY_REMOVE :
                    ALGO_TYPE.COMMODITY
            ) :
            imageType == IMAGE_TYPE.CLOTHES ? ALGO_TYPE.CLOTHES : ""
        const projectRes = await projectCreate({
            id: projectId,
            imageType,
            algoType,
            inpaint: {
                algoId: inpaintAlgoId,
                attr: {
                    ...lastInpaintAttr,
                    person: lastInput.mote_style,
                    background: imageType == IMAGE_TYPE.CLOTHES ? lastInput.bkg_style : lastInput.mote_bg_style,
                },
            },
            inputImage: inputImage,
            mask: {
                algoId: maskAlgoId,
                editedOutput: editedOutput,
            },
            projectName,
            imageAntispamId
        })
        if (!projectRes) return false

        const {taskList} = projectRes
        const checkRes =  await checkTaskStatus(taskList)
        if (!checkRes) return false
        
        return projectId
    } catch (err) {
        message.error(err?.message)
    }
}

// 更换模特/场景
export const workflowOfChange = async (
    taskId,
    imageType,
    projectName,
    changedModel,
    changedBg,
    filter,
    // isSelfDefined, // tryon暂不支持更换姿势，这里先注释掉
    // selfDefinedImg
) => {
    if (imageType == IMAGE_TYPE.COMMODITY) {
        message.warning('商品图不支持此操作')
        return false
    }
    try {
        const [ver, res] = await Promise.all([
            API.getVersion(), // 单独调用接口，获取version，用来替换以前任务的version
            API.getTaskInfo({ taskId: taskId })
        ])
        if (!res || res.code != 0 || !res.data) throw new Error(res?.message)

        const version = 
            (imageType == IMAGE_TYPE.COMMODITY ? // 商品
                ver?.commodityVersion :
                imageType == IMAGE_TYPE.CLOTHES ? // tryon
                    ver?.tryOnVersion :
                    ver?.modelVersion
            ) ||    
            res.data.inpaint?.attr?.version // 兼容写法
        const projectId = res.data.projectId
        const lastInput = res.data.inpaint?.input
        const lastInpaintAttr = res.data.inpaint?.attr // 此处需要检查模特/场景是否有更新
        const lastMask = res.data.mask
        const lastInputImage = lastMask?.input
        const recentAlgoId = res.data.inpaint?.algoId

        if (imageType == IMAGE_TYPE.CLOTHES) {
            const modelInpaintId = res.data?.inpaint?.attr?.modelInpaintId
            if (!modelInpaintId) {
                message.warning('衣服图类型不支持此操作')
                return false
            }

            const outputs = res.data?.inpaint?.outputs
            if (outputs?.length < 3) {
                console.log('can`t continue...', 5)
                PSAIModal.confirm({
                    title: '无法继续，需重选模特和场景后生成',
                    content: '版本已更新，无法复用之前的选择，请重选模特和场景',
                    okText: '去重选',
                    cancelText: '取消',
                    onOk() {
                        reselectModelAndBackground(taskId, imageType, projectName)
                    },
                    onCancel() {},
                })
                return false
            }

            const res2 = await API.getInpaintPredictionById(modelInpaintId)
            if (!res2 || res2.code != 0 || !res2.data) throw new Error(res2?.message)
            const {mote_style, mote_bg_style, seed, sub_bgid} = res2.data.input
            lastInput.mote_style = mote_style
            lastInput.bkg_style = mote_bg_style
            lastInput.seed = seed
            lastInput.sub_bgid = sub_bgid
        }

        if (imageType == IMAGE_TYPE.CLOTHES) {
            const { bkg_style, mote_style } = lastInput
            if ((/_random$/.test(bkg_style) || /_default_style$/.test(mote_style))) { // 随机时不能复刻
                message.warning('版本已更新，旧版随机生成的任务不支持更换模特/场景')
                return false
            }
        } else {
            const { mote_bg_style, mote_style } = lastInput
            if ((/_random$/.test(mote_bg_style) || /_default_style$/.test(mote_style))) { // 随机时不能复刻
                message.warning('版本已更新，旧版随机生成的任务不支持更换模特/场景')
                return false
            }
        }

        // 此处需要替换模特/场景
        if (changedModel) {
            lastInpaintAttr.person = changedModel
            lastInpaintAttr.modelFilter = filter
            lastInput.mote_style = changedModel
        }
        if (changedBg) {
            lastInpaintAttr.background = changedBg
            if (imageType == IMAGE_TYPE.CLOTHES) lastInput.bkg_style = changedBg
            else lastInput.mote_bg_style = changedBg

            if (lastInput.defined_flag == 1) { // 自定义场景
                lastInput.defined_flag = 0 // 更换场景，需要将defined_flag置为0
                if (lastInput.prompt) lastInput.prompt = ""
                if (lastInput.bkg_url) lastInput.bkg_url = ""
            }
        }

        const BgAndModelIsNotExpired = await checkBgAndModelExpired(imageType, taskId, projectName, lastInpaintAttr, lastInput)
        if (!BgAndModelIsNotExpired) return false

        let {isNotExpired, formartParams} = await checkInpaintPredictionParamsExpired({...lastInput, version}, taskId, projectName, imageType)
        if (!isNotExpired) return false

        // 由于mote_bg_style可能会改，这里需要重置一下keep_bkg
        if (formartParams.defined_flag == 1) {
            formartParams.keep_bkg = 0
        } else {
            if (formartParams.keep_bkg == 1) {
                // 场景裂变
            } else if (formartParams.mote_bg_style == '00_keep') {
                formartParams.keep_bkg = 2
            } else {
                formartParams.keep_bkg = 0
            }
        }

        // 如果更换场景，需要重置sub_bgid；
        // 如果更换模特，需要重置seed
        if (changedModel) formartParams.seed = -1
        if (changedBg) formartParams.sub_bgid = -1
        
        // const { modelFilter } = lastInpaintAttr
        if (/_random$/.test(changedBg) || /_default_style$/.test(changedModel)) { // 更换的场景或模特是随机，需要更新参数modelKeyList和bgKeyList
            // if (!modelFilter) { // 旧版生成无法
            //     PSAIModal.confirm({
            //         title: '无法继续，需重选模特和场景后生成',
            //         content: '版本已更新，旧版随机生成的任务不支持更换模特/场景，请重选模特和场景',
            //         okText: '去重选',
            //         cancelText: '取消',
            //         onOk() {
            //             reselectModelAndBackground(taskId, imageType, projectName)
            //         },
            //         onCancel() {},
            //     })
            //     return false
            // }
            formartParams = await updateInpaintPredictionParamsForRandom(formartParams, lastInpaintAttr, imageType, taskId, projectName)
        }

        // tryon 更换场景生成需要增加参数
        if (imageType == IMAGE_TYPE.CLOTHES) {
            if (changedModel || changedBg) formartParams.recentAlgoId = recentAlgoId
            if (changedModel && lastInput.keepPose == 1) lastInput.keepPose = 0 // 更换模特，如果原来是【保持模特】，需要将【保持模特】属性改为false
            // 支持自定义模特
            formartParams.t_model = 3 // 取值1,2,3 全身区域分割v0.2已更新，t_model 传3
            // tryon暂不支持更换姿势，这里先注释掉
            // formartParams.self_defined = isSelfDefined ? 1 : 0 // 自定义flag
            // formartParams.mote_img = isSelfDefined ? selfDefinedImg : '' // 用户上传得模特图，用于构建模特

            // 衣服图的cloth_type目前仅与上传的衣服数量有关：0-上装；1-下装；2-上下装；3-裙装；by ligd 20240517
            if (lastMask.topAlgoId && lastMask.bottomAlgoId) formartParams.cloth_type = 2
            else if (lastMask.topAlgoId) formartParams.cloth_type = 0
            else if (lastMask.bottomAlgoId) formartParams.cloth_type = 1
            else formartParams.cloth_type = 3
        }

        // 生成图片数，默认为4
        formartParams.num = formartParams.num || 4

        const inpaintAlgoId = await inpaintPrediction(formartParams, imageType, true)
        if (!inpaintAlgoId) return false

        // 算法类型
        const algoType = 
            imageType == IMAGE_TYPE.MODEL ? ALGO_TYPE.MODEL :
            imageType == IMAGE_TYPE.DRESSFORM ? ALGO_TYPE.DRESSFORM :
            imageType == IMAGE_TYPE.COMMODITY ? (
                formartParams.refine_version == 3 ?
                    ALGO_TYPE.COMMODITY_REMOVE :
                    ALGO_TYPE.COMMODITY
            ) :
            imageType == IMAGE_TYPE.CLOTHES ? ALGO_TYPE.CLOTHES : ""
        const projectRes = await projectCreate({
            id: projectId,
            imageType,
            algoType,
            inpaint: {
                algoId: inpaintAlgoId,
                attr: {
                    ...lastInpaintAttr,
                    person: lastInput.mote_style,
                    background: imageType == IMAGE_TYPE.CLOTHES ? lastInput.bkg_style : lastInput.mote_bg_style,
                },
            },
            inputImage: lastInputImage,
            mask: lastMask,
            projectName,
        })
        if (!projectRes) return false

        const {taskList} = projectRes
        const checkRes =  await checkTaskStatus(taskList)
        if (!checkRes) return false
        
        return projectId
    } catch (err) {
        message.error(err?.message)
    }
}

// 重新生成的流程
export const workflowOfRebuild = async (taskId, imageType, projectName) => {
    try {
        const [ver, res] = await Promise.all([
            API.getVersion(), // 单独调用接口，获取version，用来替换以前任务的version
            API.getTaskInfo({ taskId: taskId })
        ])
        if (!res || res.code != 0 || !res.data) throw new Error(res?.message)

        const version = 
            (imageType == IMAGE_TYPE.COMMODITY ? // 商品
                ver?.commodityVersion :
                imageType == IMAGE_TYPE.CLOTHES ? // tryon
                    ver?.tryOnVersion :
                    ver?.modelVersion
            ) ||
            res.data.inpaint?.attr?.version // 兼容写法
        const projectId = res.data.projectId
        const lastInput = res.data.inpaint?.input
        const lastInpaintAttr = res.data.inpaint?.attr // 此处需要检查模特/场景是否有更新
        const lastMask = res.data.mask
        const lastInputImage = lastMask?.input
        const recentAlgoId = res.data.inpaint?.algoId

        const BgAndModelIsNotExpired = await checkBgAndModelExpired(imageType, taskId, projectName, lastInpaintAttr)
        if (!BgAndModelIsNotExpired) return false

        if (imageType == IMAGE_TYPE.CLOTHES) {
            const modelInpaintId = res.data?.inpaint?.attr?.modelInpaintId
            if (!modelInpaintId) {
                message.warning('衣服图类型不支持此操作')
                return false
            }

            const outputs = res.data?.inpaint?.outputs
            if (outputs?.length < 3) {
                console.log('can`t continue...', 6)
                PSAIModal.confirm({
                    title: '无法继续，需重选模特和场景后生成',
                    content: '版本已更新，无法复用之前的选择，请重选模特和场景',
                    okText: '去重选',
                    cancelText: '取消',
                    onOk() {
                        reselectModelAndBackground(taskId, imageType, projectName)
                    },
                    onCancel() {},
                })
                return false
            }

            const res2 = await API.getInpaintPredictionById(modelInpaintId)
            if (!res2 || res2.code != 0 || !res2.data) throw new Error(res2?.message)
            const {mote_style, mote_bg_style, seed, sub_bgid} = res2.data.input
            lastInput.mote_style = mote_style
            lastInput.bkg_style = mote_bg_style
            lastInput.seed = seed
        }

        let {isNotExpired, formartParams} = await checkInpaintPredictionParamsExpired({...lastInput, version}, taskId, projectName, imageType)
        if (!isNotExpired) return false

        // 需要重置seed和sub_bgid
        formartParams.seed = -1
        formartParams.sub_bgid = -1

        const { person, background, modelFilter } = lastInpaintAttr
        if (/_random$/.test(background) || /_default_style$/.test(person)) { // 非复刻且随机，需要更新参数modelKeyList和bgKeyList
            // if (imageType != IMAGE_TYPE.COMMODITY && !modelFilter) { // 旧版生成无法
            //     PSAIModal.confirm({
            //         title: '无法继续，需重选模特和场景后生成',
            //         content: '版本已更新，无法使用旧版本的随机生成，请重选模特和场景',
            //         okText: '去重选',
            //         cancelText: '取消',
            //         onOk() {
            //             reselectModelAndBackground(taskId, imageType, projectName)
            //         },
            //         onCancel() {},
            //     })
            //     return false
            // }
            // 重新生成时,如果是随机,需要将mote_style和mote_bg_style重置为person和background
            if (imageType == IMAGE_TYPE.CLOTHES) {
                formartParams.bkg_style = background
                formartParams.mote_style = person
            } else if (imageType == IMAGE_TYPE.COMMODITY) {
                formartParams.goods_bg_style = background
            } else {
                formartParams.mote_bg_style = background
                formartParams.mote_style = person
            }
            formartParams = await updateInpaintPredictionParamsForRandom(formartParams, lastInpaintAttr, imageType, taskId, projectName)
        }

        if (!formartParams) return false

        // tryon 生成更多需要增加参数
        if (imageType == IMAGE_TYPE.CLOTHES) {
            formartParams.recentAlgoId = recentAlgoId

            // 衣服图的cloth_type目前仅与上传的衣服数量有关：0-上装；1-下装；2-上下装；3-裙装；by ligd 20240517
            if (lastMask.topAlgoId && lastMask.bottomAlgoId) formartParams.cloth_type = 2
            else if (lastMask.topAlgoId) formartParams.cloth_type = 0
            else if (lastMask.bottomAlgoId) formartParams.cloth_type = 1
            else formartParams.cloth_type = 3
        }

        // 生成图片数，默认为4
        formartParams.num = formartParams.num || 4
        
        const inpaintAlgoId = await inpaintPrediction(formartParams, imageType)
        if (!inpaintAlgoId) return false

        // 算法类型
        const algoType = 
            imageType == IMAGE_TYPE.MODEL ? ALGO_TYPE.MODEL :
            imageType == IMAGE_TYPE.DRESSFORM ? ALGO_TYPE.DRESSFORM :
            imageType == IMAGE_TYPE.COMMODITY ? (
                formartParams.refine_version == 3 ?
                    ALGO_TYPE.COMMODITY_REMOVE :
                    ALGO_TYPE.COMMODITY
            ) :
            imageType == IMAGE_TYPE.CLOTHES ? ALGO_TYPE.CLOTHES : ""
        const projectRes = await projectCreate({
            id: projectId,
            imageType,
            algoType,
            inpaint: {
                algoId: inpaintAlgoId,
                attr: lastInpaintAttr,
            },
            inputImage: lastInputImage,
            mask: lastMask,
            projectName,
        })
        if (!projectRes) return false
        
        const {taskList} = projectRes
        return await checkTaskStatus(taskList)
    } catch (err) {
        message.error(err?.message)
    }
}

// 生成流程
export const workflowOfBuild = (params, imageType, proInfo, imageAntispamId) => {
    return inpaintPrediction(params, imageType, false).then(inpaintAlgoId => {
        if (!inpaintAlgoId) return false
        proInfo = {
            ...proInfo,
            inpaint: { ...proInfo.inpaint, algoId: inpaintAlgoId },
            imageAntispamId: imageAntispamId || ''
        }
        return projectCreate(proInfo).then((projectRes) => {
            if (!projectRes) return false

            const {id, taskList} = projectRes
            proInfo = { ...proInfo, id, }
            return checkTaskStatus(taskList).then(res => {
                if (res) return id
                else return false
            })
        }).catch(err => {
            message.error(err?.message)
        })
    })
}


export default {
    projectCreate,
    checkTaskStatus,
    workflowOfReplica,
    workflowOfRebuild,
    workflowOfChange,
    workflowOfBuild,
}